/** Parse CED userId from Zoom JWT user_identity / userKey: "{cedUserId}_{random5or6}". */
export function parseCedUserIdFromIdentity(identity) {
  if (!identity || typeof identity !== 'string') return null;
  const trimmed = identity.trim();
  const match = trimmed.match(/^(.+)_([a-zA-Z0-9]{5,6})$/);
  return match ? match[1] : null;
}

export function getParticipantCedUserId(participant) {
  if (!participant || typeof participant !== 'object') return null;
  return parseCedUserIdFromIdentity(participant.userKey || participant.userIdentity);
}

export function resolveMyCedUserId(reduxUser, currentParticipant) {
  const fromRedux = reduxUser?._id || reduxUser?.cedUserId;
  if (fromRedux != null && String(fromRedux).trim()) {
    return String(fromRedux).trim();
  }
  return getParticipantCedUserId(currentParticipant);
}

export function findSameCedUserParticipants(users, cedUserId, excludeZoomUserId) {
  if (!cedUserId || !Array.isArray(users)) return [];
  return users.filter((participant) => {
    if (excludeZoomUserId != null && participant.userId === excludeZoomUserId) {
      return false;
    }
    return getParticipantCedUserId(participant) === cedUserId;
  });
}

export function hasSameUserWithMicOn(users, cedUserId, excludeZoomUserId) {
  return findSameCedUserParticipants(users, cedUserId, excludeZoomUserId).some(
    (participant) => participant.muted === false,
  );
}

export function hasSameCedUserInList(participants, cedUserId, excludeZoomUserId) {
  return findSameCedUserParticipants(participants, cedUserId, excludeZoomUserId).length > 0;
}

export function normalizeParticipantEventPayload(payload) {
  if (payload == null) return [];
  return Array.isArray(payload) ? payload : [payload];
}

export function participantUserIdsMatch(a, b) {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

/** Zoom báo muted của chính mình trễ sau startAudio; mic local tắt thì ép self muted: true. */
export function withSelfMutedWhenMicOff(users, selfZoomUserId, isMicOn) {
  if (isMicOn || selfZoomUserId == null || !Array.isArray(users)) return users;
  let changed = false;
  const next = users.map((participant) => {
    if (!participantUserIdsMatch(participant.userId, selfZoomUserId) || participant.muted === true) {
      return participant;
    }
    changed = true;
    return { ...participant, muted: true };
  });
  return changed ? next : users;
}
